import { Flex } from "@/atoms"
import { useNumberConvertor } from "@/hooks/useNumberConvertor"
import { useTranslation } from "@/hooks/useTranslation"
import { StatisticWidget, Widget } from "@/molecules/Widget"
import { ActionTypeIcon } from "../../molecules/ActionTypeIcon"
import { ACTIONS_TAKEN_TILE_GROUPS } from "./ActionsTakenWidget.constants"

import styles from "./ActionsTakenWidget.module.scss"

import type { ActionsTakenWidgetComponentProps } from "./ActionsTakenWidget.types"

export const ActionsTakenWidgetComponent = ({
  isLoading,
  ...counts
}: ActionsTakenWidgetComponentProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "settings.automatedActions.widgets"
  })
  const { abbreviateNumber } = useNumberConvertor()

  return (
    <Widget className={styles.actionsWidget}>
      <Flex gap={8} flex={1} wrap className={styles.tiles}>
        {ACTIONS_TAKEN_TILE_GROUPS.map((group) => (
          <Flex key={group[0]} gap={8} wrap className={styles.tileGroup}>
            {group.map((type) => (
              <StatisticWidget
                key={type}
                flex
                border
                alignValueBottom
                className={styles.tile}
                title={t(`actions.${type}`)}
                value={abbreviateNumber(counts[type] || 0)}
                icon={<ActionTypeIcon type={type} />}
                loading={isLoading}
              />
            ))}
          </Flex>
        ))}
      </Flex>
    </Widget>
  )
}
